export default __webpack_public_path__ + "static/media/home.9e5c6568.jpg";